/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAccount, useDisconnect, useNetwork } from "wagmi";
import Web3 from "web3";
import { db } from "../config/fireBaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import {
  formatUTC,
  getBalanceMethod,
  getParseEnvChainIds,
  getUnstakeDate,
} from "utils/helper";
import useChainAbiAddressAndUrl from "hooks/useChainAbiAddress";
import NoEthWalletModal from "components/modals/NotExtetionModal";
import { readContract } from "@wagmi/core";

import polygonStakeAbi from "../json/abi/polygon/PolygonStakeAbi.json";
import ethStakeAbi from "../json/abi/ethereum/EthStakeAbi.json";

const MyContext = createContext({});

export const AppContext = ({ children }) => {
  const envChainId = getParseEnvChainIds();
  const [isApproving, setIsApproving] = useState(false);
  const [walletBalance, setWalletBalance] = useState("");
  const [stakedBalance, setStakedBalance] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [timeLeftToUnstake, setTimeLeftToUnstake] = useState(null);
  const [unstakeTimeStamp, setUnstakeTimeStamp] = useState(0);
  const [currentState, setCurrentState] = useState("");
  const [unstakedDate, setUnstakedDate] = useState(null);
  // const [isVotingActive, setIsVotingActive] = useState(false);
  // const [isStakingPhaseActive, setIsStakingPhaseActive] = useState(false);
  // const [canUnstake, setCanUnstake] = useState(false);
  const [hasUnstaked, setHasUnstaked] = useState(false);
  const [hasStaked, setHasStaked] = useState(false);
  const [minStakeBalance, setMinStakeBalance] = useState("");
  const [approvedBalance, setApprovedBalance] = useState("");
  const [userData, setUserData] = useState([]);
  const [coolDownPeriod, setCoolDownPeriod] = useState("");
  const [unStakeSelected, setUnStakeSelected] = useState(false);
  const [unStakedBalance, setUnStakedBalance] = useState("");
  const [date, setDate] = useState();
  const { chain } = useNetwork();
  const [networkSelected, setNetworkSelected] = useState(null);
  const [loader, setLoader] = useState(false);

  const [tHash, setTHash] = useState(localStorage.getItem("T_HASH") ?? "");
  const [transactionData, setTransactionData] = useState({
    status: JSON.parse(
      JSON.stringify(localStorage.getItem("T_STATUS") ?? null)
    ),
    txType: "",
  });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentProvider, setCurrentProvider] = useState(null);
  const [showWalletSidebar, setShowWalletSidebar] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState("");
  const [maticBalance, setMaticBalance] = useState("");
  const [isSignWallet, setIsSignWallet] = useState(
    localStorage.getItem("wagmi.walletSignature") ?? false
  );
  const [afterClaimLoading, setAfterClaimLoading] = useState(false);

  const { disconnect } = useDisconnect();
  const { connector, address } = useAccount();
  const [progress, setProgress] = useState("");

  const user_data = [];
  const web3Provider = new Web3.providers.HttpProvider(
    networkSelected === envChainId[0]
      ? `${process.env.REACT_APP_INFURA_URL}${process.env.REACT_APP_INFURA_KEY}`
      : process.env.REACT_APP_ETH_SEPOLIA_URL
  );
  const {
    tvkContractAddress,
    tvkStakeContractAddress,
    tvkAbi,
    stakeAbi,
    transactionUrl,
  } = useChainAbiAddressAndUrl(networkSelected);

  const handleGetEthProvider = async (obj) => {
    const Provider = obj.hasAddress
      ? await connector?.getProvider()
      : window.ethereum
      ? window.ethereum
      : web3Provider;

    setCurrentProvider(Provider);
  };

  const handleAddTrxToDB = async (txId, to, from, tvk, txType) => {
    const currentDate = new Date();
    const formattedDate = currentDate.setUTCDate(currentDate.getUTCDate());
    const id = from;
    const userTransactionJson = {
      txId,
      to,
      from,
      date: formattedDate,
      tvk,
      txType,
    };

    try {
      await addDoc(
        collection(db, "virtua_binary", id, "transactions"),
        userTransactionJson
      );
    } catch (e) {
      // console.error("Error adding document: ", e);
    }
  };

  const fetchData = async () => {
    try {
      // setLoader(true);
      const colRef = collection(db, "virtua_binary", address, "transactions");
      const querySnapshot = await getDocs(colRef);
      const q = query(
        collection(db, "virtua_binary", address, "transactions"),
        orderBy("date", "desc")
      );

      const querySnapshot2 = await getDocs(q);
      const latestTransaction = [];

      querySnapshot2.forEach((doc) => {
        if (doc?.data()?.txType === "TokensUnstaked") {
          latestTransaction.push({ ...doc.data(), id: doc.id });
        }
      });
      if (latestTransaction[0]?.date) {
        setUnStakedBalance(latestTransaction[0]?.tvk);
        afterClaimLoading &&
          setTimeout(() => {
            setAfterClaimLoading(false);
          }, 1000);
        if (typeof latestTransaction[0]?.date === "number") {
          setUnstakedDate(formatUTC(latestTransaction[0]?.date, ""));
        } else {
          setUnstakedDate(latestTransaction[0].date);
        }
      } else {
        setUnStakedBalance("");
      }

      querySnapshot?.forEach((doc) => {
        if (doc.data()?.txType === "Stake") {
          user_data.push({
            id: doc.id,
            ...doc.data(),
          });
          setUserData(user_data);
        }
      });
    } catch (error) {
      // console.error(error);
    }
  };

  const handleDisConnectWallet = async () => {
    localStorage.removeItem("wagmi.nonce");
    localStorage.removeItem("wagmi.walletAddress");
    localStorage.removeItem("wagmi.chainId");
    localStorage.removeItem("isSigned");
    localStorage.removeItem("wagmi.walletSignature");
    localStorage.removeItem("wagmi.walletMessage");
    localStorage.setItem("networkSelected", null);
    disconnect();
    setWalletBalance("");
    setApprovedBalance("");
    setIsSignWallet(false);
    setCurrentProvider(null);
    handleManageStatus();
  };

  const handleOpenCloseWalletSidebar = () => {
    setShowWalletSidebar((prev) => !prev);
  };

  const handleOpenCloseErrorModal = (booleanVal) => {
    if (booleanVal) {
      setShowErrorModal(true);
    } else {
      setShowErrorModal(false);
    }
  };

  const handleIsApproving = (booleanVal) => {
    if (booleanVal) {
      setIsApproving(true);
    } else {
      setIsApproving(false);
    }
  };
  const handleSignFromWallet = (booleanVal) => {
    if (booleanVal) {
      setIsSignWallet(true);
    } else {
      setIsSignWallet(false);
    }
  };

  const handleManageStatus = (hash, txType) => {
    if (hash) {
      setTHash(hash);
      localStorage.setItem("T_HASH", hash);
      setTransactionData({ status: "Pending", txType });
      localStorage.setItem("T_STATUS", "Pending");
    } else {
      setTHash("");
      setTransactionData({ status: null, txType: "" });
      localStorage.setItem("T_STATUS", null);
      localStorage.removeItem("T_HASH");
    }
  };

  const handleFetchBalance = async () => {
    if (tvkContractAddress && currentProvider && address) {
      const contractConfig = {
        address: tvkContractAddress,
        abi: tvkAbi,
        functionName: "balanceOf",
        args: [address],
      };
      getBalanceMethod(contractConfig, currentProvider)
        .then((amount) => {
          setWalletBalance(amount);
          handleAllowanceBalance();
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handleFetchMinimumStakeBalance = async () => {
    if (tvkStakeContractAddress && currentProvider && address) {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "minStakeAmount",
      };
      getBalanceMethod(contractConfig, currentProvider)
        .then((amount) => {
          setMinStakeBalance(Number(amount));
        })
        .catch(() => {});
    }
  };

  const handleFetchStakedBalance = async () => {
    if (tvkStakeContractAddress && currentProvider && address) {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "balanceOf",
        args: [address],
      };
      getBalanceMethod(contractConfig, currentProvider)
        .then((amount) => {
          setStakedBalance(amount);
          handleAllowanceBalance();
        })
        .catch(() => {});
    }
  };

  const handleFetchMaticBalance = async () => {
    if (tvkContractAddress && currentProvider && address) {
      try {
        const web3 = new Web3(currentProvider);
        const maticBalance = await web3.eth.getBalance(address);
        let amount = web3.utils.fromWei(maticBalance, "ether");
        setMaticBalance(Number(amount));
        return Number(amount);
      } catch (error) {
        throw new Error(error);
      }
    }
  };

  const handleFetchTimeLeftToUnstake = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "getTimeLeftToUnstake",
        args: [address],
      };
      let timeLeft = await readContract({
        ...contractConfig,
      });
      console.log(timeLeft, "time");
      setTimeLeftToUnstake(timeLeft);
    } catch (error) {}
  };

  const handleFetchUnstakeTimeStamp = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "stakingInfo",
        args: [address],
      };
      let timeLeft = await readContract({
        ...contractConfig,
      });
      setUnstakeTimeStamp(timeLeft[3]);
    } catch (error) {}
  };

  const handleFetchHasUnstaked = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "stakingInfo",
        args: [address],
      };
      let timeLeft = await readContract({
        ...contractConfig,
      });
      setHasUnstaked(timeLeft[2]);
    } catch (error) {}
  };
  const handleFetchHasStaked = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "stakingInfo",
        args: [address],
      };
      let timeLeft = await readContract({
        ...contractConfig,
      });
      setHasStaked(timeLeft[1]);
    } catch (error) {}
  };

  const handleAllowanceBalance = async () => {
    const contractConfig = {
      address: tvkContractAddress,
      abi: tvkAbi,
      functionName: "allowance",
      args: [address, tvkStakeContractAddress],
    };
    getBalanceMethod(contractConfig, currentProvider)
      .then((amount) => {
        setApprovedBalance(amount);
      })
      .catch((err) => {
        // console.log(err)
      });
  };

  const handleFetchCurrentStateWithoutConnetWallet = async () => {
    try {
      const env = process.env.REACT_APP_ENV;
      const contractConfig = {
        address:
          env === "PROD"
            ? process.env.REACT_APP_TVK_ETHEREUM_STAKE_CONTRACT_ADDRESS
            : process.env.REACT_APP_TVK_POLYGON_STAKE_CONTRACT_ADDRESS,
        abi: env === "PROD" ? ethStakeAbi : polygonStakeAbi,
      };

      let currentState = await readContract({
        ...contractConfig,
        functionName: "getCurrentState",
      });

      setCurrentState(currentState);
    } catch (error) {
      setCurrentState("No State");
      console.log(error, "err");
    }
  };
  const handleFetchCurrentState = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
      };
      let currentState = await readContract({
        ...contractConfig,
        functionName: "getCurrentState",
      });

      setCurrentState(currentState);
      if (currentState === "UnStake State" && address) {
        handleFetchUnstakeTimeStamp();
        handleFetchHasStaked();
        handleFetchHasUnstaked();
      }
    } catch (error) {
      setCurrentState("No State");
      // console.log(error, "err");
    }
  };

  const handleFetchCoolDownPeriod = async () => {
    try {
      const contractConfig = {
        address: tvkStakeContractAddress,
        abi: stakeAbi,
        functionName: "cooldownPeriod",
      };
      let data = await readContract({
        ...contractConfig,
      });
      setCoolDownPeriod(Number(data));
    } catch (error) {}
  };

  const hadndleProgress = () => {
    if (approvedBalance > 0 && !hasStaked) {
      setProgress(75);
    } else if (hasStaked) {
      setProgress(100);
    } else if (address) {
      setProgress(50);
    } else {
      setProgress(25);
    }
  };

  useEffect(() => {
    if (address) {
      if (stakeAbi && tvkStakeContractAddress) {
        handleFetchCurrentState();
      }
    }
  }, [
    currentProvider,
    networkSelected,
    stakeAbi,
    tvkStakeContractAddress,
    isSignWallet,
    address,
  ]);

  useEffect(() => {
    if (!address) {
      handleFetchCurrentStateWithoutConnetWallet();
    }
  }, [isSignWallet, address]);

  useEffect(() => {
    let interval = null;
    handleFetchTimeLeftToUnstake();
    if (currentState === "UnStake State" && hasUnstaked && stakedBalance > 0) {
      interval = setInterval(() => {
        handleFetchTimeLeftToUnstake();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [hasUnstaked, currentState, stakedBalance]);

  useEffect(() => {
    hadndleProgress();
  }, [isSignWallet, approvedBalance, stakedBalance]);

  useEffect(() => {
    fetchData();

    if (currentProvider && address && networkSelected && tvkContractAddress) {
      localStorage.setItem("networkSelected", chain?.id ?? networkSelected);
      handleFetchCoolDownPeriod();
      handleFetchBalance();
      handleFetchStakedBalance();
      handleFetchMinimumStakeBalance();
      handleFetchHasStaked();
    }
  }, [
    address,
    currentProvider,
    stakedBalance,
    minStakeBalance,
    hasStaked,
    networkSelected,
    tvkContractAddress,
    tvkStakeContractAddress,
    stakeAbi,
    tvkAbi,
    chain,
  ]);

  useEffect(() => {
    // setTimeout(() => {

    if (!isSignWallet && !address) {
      handleGetEthProvider({ hasAddress: false });
    } else {
      handleGetEthProvider({ hasAddress: true });
    }
    // }, [2000]);
  }, [connector, address]);
  //To detect network change of connected wallet

  useEffect(() => {
    connector?.getChainId().then((id) => {
      console.log(id);
      if (networkSelected) {
        if (networkSelected !== id) {
          document.location.reload(true);
        }
      }
      setNetworkSelected(Number(id));
    });
  }, [connector, chain?.id]);
  useEffect(() => {
    let clearTime;

    if (currentProvider && tHash && transactionData?.status !== "Completed") {
      clearTime = setInterval(() => {
        const web3 = new Web3(currentProvider);
        web3.eth.getTransaction(tHash).then((t) => {
          if (transactionData?.txType === "unstake and claimed") {
            setAfterClaimLoading(true);
          }
          if (t?.blockHash) {
            web3.eth.getTransactionReceipt(t?.hash).then((r) => {
              if (Number(window.BigInt(r?.status)) > 0) {
                fetchData();
                handleManageStatus();
                handleFetchCoolDownPeriod();
                handleFetchBalance();
                handleFetchStakedBalance();
                handleFetchCurrentState();
                handleFetchMinimumStakeBalance();
                handleFetchHasStaked();
                if (
                  transactionData?.txType === "approval" ||
                  transactionData?.txType === "staking" ||
                  transactionData?.txType === "unstaking" ||
                  transactionData?.txType === "unstake and claimed"
                ) {
                  setTransactionStatus("completed");
                  const tvk = localStorage.getItem("inputVal");
                  if (transactionData?.txType === "approval") {
                    fetchData();
                    handleAddTrxToDB(
                      t?.hash,
                      tvkContractAddress,
                      address,
                      tvk,
                      "Approval"
                    ).then(() => {
                      localStorage.removeItem("inputVal");
                    });
                  } else if (transactionData?.txType === "unstaking") {
                    setUnStakeSelected(true);
                    handleAddTrxToDB(
                      t?.hash,
                      tvkStakeContractAddress,
                      address,
                      stakedBalance,
                      "UnStakeStarted"
                    );
                    setDate(getUnstakeDate(unstakeTimeStamp));
                  } else if (
                    transactionData?.txType === "unstake and claimed"
                  ) {
                    setUnStakeSelected(true);
                    handleAddTrxToDB(
                      t?.hash,
                      tvkStakeContractAddress,
                      address,
                      stakedBalance,
                      "TokensUnstaked"
                    );
                    setTimeout(()=>{
                      setAfterClaimLoading(false);
                    },3000)
                  } else {
                    setSuccessModal(true);
                    handleAddTrxToDB(
                      t?.hash,
                      tvkStakeContractAddress,
                      address,
                      tvk,
                      "TokenStake"
                    ).then(() => {
                      localStorage.removeItem("inputVal");
                    });
                  }
                }
              } else {
                setSuccessModal(false);
                handleManageStatus();
                if (
                  transactionData?.txType === "staking" ||
                  transactionData?.txType === "approval" ||
                  transactionData?.txType === "unstaking" ||
                  transactionData?.txType === "unstake and claimed"
                ) {
                  setUnStakeSelected(false);
                  setTransactionStatus("failed");
                  setAfterClaimLoading(false);
                }
              }
            });
          }
        });
      }, 3000);
    }
    return () => {
      clearInterval(clearTime);
    };
  }, [
    currentProvider,
    tHash,
    transactionStatus,
    stakedBalance,
    minStakeBalance,
    hasStaked,
    networkSelected,
  ]);

  return (
    <MyContext.Provider
      value={{
        isApproving: isApproving,
        maticBalance: maticBalance,
        isSignWallet: isSignWallet,
        walletBalance: walletBalance,
        showErrorModal: showErrorModal,
        transactionData: transactionData,
        currentProvider: currentProvider,
        approvedBalance: approvedBalance,
        transactionStatus: transactionStatus,
        showWalletSidebar: showWalletSidebar,
        userData: userData,
        stakedBalance: stakedBalance,
        transactionUrl: transactionUrl,
        minStakeBalance: minStakeBalance,
        setSuccessModal: setSuccessModal,
        networkSelected: networkSelected,
        setNetworkSelected: setNetworkSelected,
        hasStaked: hasStaked,
        successModal: successModal,
        hasUnstaked: hasUnstaked,
        progress: progress,
        tvkAbi: tvkAbi,
        setDate: setDate,
        address: address,
        timeLeftToUnstake: timeLeftToUnstake,
        unstakeTimeStamp: unstakeTimeStamp,
        date: date,
        loader: loader,
        stakeAbi: stakeAbi,
        currentState: currentState,
        coolDownPeriod: coolDownPeriod,
        unStakeSelected: unStakeSelected,
        tvkContractAddress: tvkContractAddress,
        tvkStakeContractAddress: tvkStakeContractAddress,
        unstakedDate: unstakedDate,
        unStakedBalance: unStakedBalance,
        afterClaimLoading: afterClaimLoading,
        handleAddTrxToDB: handleAddTrxToDB,
        handleIsApproving: handleIsApproving,
        handleManageStatus: handleManageStatus,
        handleFetchBalance: handleFetchBalance,
        setTransactionStatus: setTransactionStatus,
        handleSignFromWallet: handleSignFromWallet,
        handleDisConnectWallet: handleDisConnectWallet,
        handleAllowanceBalance: handleAllowanceBalance,
        handleFetchMaticBalance: handleFetchMaticBalance,
        handleOpenCloseErrorModal: handleOpenCloseErrorModal,
        handleOpenCloseWalletSidebar: handleOpenCloseWalletSidebar,
        // handleFetchTotalContractBalance: handleFetchTotalContractBalance,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useContextValues = () => {
  const {
    isSwapping,
    isApproving,
    isSignWallet,
    maticBalance,
    walletBalance,
    showErrorModal,
    transactionData,
    approvedBalance,
    progress,
    hasUnstaked,
    currentProvider,
    tvkAbi,
    address,
    stakeAbi,
    transactionUrl,
    tvkContractAddress,
    unstakeTimeStamp,
    tvkStakeContractAddress,
    transactionStatus,
    showWalletSidebar,
    networkSelected,
    setNetworkSelected,
    timeLeftToUnstake,
    unstakedDate,
    userData,
    setDate,
    date,
    loader,
    afterClaimLoading,
    unStakeSelected,
    currentState,
    stakedBalance,
    minStakeBalance,
    setSuccessModal,
    successModal,
    coolDownPeriod,
    handleIsSwapping,
    handleIsApproving,
    hasStaked,
    handleManageStatus,
    handleFetchBalance,
    setTransactionStatus,
    handleSignFromWallet,
    handleAddTrxToDB,
    handleAllowanceBalance,
    handleDisConnectWallet,
    unStakedBalance,
    handleFetchMaticBalance,
    handleOpenCloseErrorModal,
    handleOpenCloseWalletSidebar,
    // handleFetchTotalContractBalance,
  } = useContext(MyContext);
  return {
    isSwapping,
    isApproving,
    isSignWallet,
    maticBalance,
    walletBalance,
    showErrorModal,
    transactionData,
    approvedBalance,
    currentProvider,
    transactionStatus,
    showWalletSidebar,
    unstakeTimeStamp,
    userData,
    progress,
    tvkAbi,
    unstakedDate,
    stakeAbi,
    setDate,
    date,
    address,
    loader,
    afterClaimLoading,
    tvkContractAddress,
    timeLeftToUnstake,
    tvkStakeContractAddress,
    networkSelected,
    setNetworkSelected,
    unStakeSelected,
    transactionUrl,
    currentState,
    coolDownPeriod,
    stakedBalance,
    setSuccessModal,
    hasStaked,
    successModal,
    hasUnstaked,
    minStakeBalance,
    handleIsSwapping,
    handleIsApproving,
    handleManageStatus,
    handleFetchBalance,
    setTransactionStatus,
    handleAddTrxToDB,
    handleSignFromWallet,
    handleAllowanceBalance,
    handleDisConnectWallet,
    handleFetchMaticBalance,
    handleOpenCloseErrorModal,
    unStakedBalance,
    handleOpenCloseWalletSidebar,

    // handleFetchTotalContractBalance,
  };
};
